import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './ui';
const FAQS = [{
  q: '¿Es seguro lo que hablo acá?',
  a: 'Totalmente. Todo lo que compartís es estrictamente confidencial. No lo divulgamos ni lo usamos para ningún otro fin.'
}, {
  q: '¿Por qué no hablo con un amigo o familiar?',
  a: 'Un amigo te conoce y puede condicionarte sin querer. Acá no hay historia previa ni prejuicios. Solo lo que vos traés.'
}, {
  q: '¿Cuánto dura la sesión?',
  a: '45 minutos completos para vos. Sin que te apuren.'
}, {
  q: '¿Qué pasa si nunca hice algo así antes?',
  a: 'No hace falta experiencia. Podés empezar diciendo que no sabés por dónde arrancar. Eso alcanza.'
}, {
  q: '¿En qué se diferencia de una app o un chat?',
  a: 'Es una conversación de voz en tiempo real. No es un chat ni mensajes. Escuchás y hablás. Eso cambia todo.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-[#1B2B4A] px-6 py-20 sm:py-28" data-id="element-12">
      <div className="mx-auto max-w-3xl" data-id="element-13">
        <FadeIn className="text-center" data-id="element-14">
          <h2 className="font-serif text-3xl text-white sm:text-4xl" data-id="element-15">
            Queremos que entres a tu sesión sin dudas.
          </h2>
        </FadeIn>

        <div className="mt-10 space-y-3" data-id="element-16">
          {FAQS.map((faq, i) => {
          const isOpen = open === i;
          return <FadeIn key={i} delay={i * 0.04} data-id="element-17">
                <div className="overflow-hidden rounded-xl border border-[#8BA3C7]/20 bg-[#213354]" data-id="element-18">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left" data-id="element-19">
                    <span className="font-serif text-lg text-white" data-id="element-20">
                      {faq.q}
                    </span>
                    <ChevronDown className={`h-5 w-5 flex-shrink-0 text-[#8BA3C7] transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-21" />
                  </button>
                  <div className={`grid transition-all duration-300 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-22">
                    <div className="overflow-hidden" data-id="element-23">
                      <p className="px-6 pb-5 leading-relaxed text-white/70" data-id="element-24">
                        {faq.a}
                      </p>
                    </div>
                  </div>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}